import { render } from "./FormHelp.vue?vue&type=template&id=1c11b32a"
import script from "./FormHelp.vue?vue&type=script&lang=js"
export * from "./FormHelp.vue?vue&type=script&lang=js"

import "./FormHelp.vue?vue&type=style&index=0&id=1c11b32a&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__